module.exports = __webpack_public_path__ + "img/activity-item-bg.75e1a5af.7347a729.png";